import { gql } from 'graphql-tag';
import { SpecificResourceRequestFragmentDoc } from '~/types';
import {
  specificResourceAllocationFragment,
  specificResourceAllocationUserFragment,
  specificResourceAllocationTimeOffFragment,
  specificResourceAllocationHolidaysFragment,
  resourceRequestTotalsFragment,
  allocationTotalsFragment,
  resourceMatchesFragment
} from '~/modules/resourcing/common/fragments';

const RESOURCE_REQUESTS_ALLOCATIONS_QUERY = gql`
  query resourceRequests(
    $cursor: String
    $limit: Int = 500
    $projectUri: String
    $filter: ResourceRequestsFilter
    $sort: ResourceRequestSort
    $requestStatusList: [ResourceRequestStatus]
    $minimumLimit: Int
    $resourceMatchesPage: Int = 1
    $resourceMatchesPageSize: Int = 1
    $isPsaPraaResourceMatchingEnabled: Boolean = false
    $chartDateRange: DateRangeInput = null
    $showHolidays: Boolean = false
    $showTimeOff: Boolean = false
  ) {
    resourceRequests(
      limit: $limit
      cursor: $cursor
      projectUri: $projectUri
      filter: $filter
      sort: $sort
      requestStatusList: $requestStatusList
      minimumLimit: $minimumLimit
    ) {
      resourceRequests {
        ...SpecificResourceRequest
        ...ResourceRequestTotalsFragment
        resourceAllocations {
          ...SpecificResourceAllocation
          user {
            ...SpecificResourceAllocationUser
            ...SpecificResourceAllocationTimeOff
            ...SpecificResourceAllocationHolidays
          }
          ...AllocationTotalsFragment
        }
        ...ResourceMatchesFragment
      }
      nextPageCursor
    }
  }
  ${SpecificResourceRequestFragmentDoc}
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
  ${specificResourceAllocationTimeOffFragment}
  ${specificResourceAllocationHolidaysFragment}
  ${resourceRequestTotalsFragment}
  ${allocationTotalsFragment}
  ${resourceMatchesFragment}
`;

export default RESOURCE_REQUESTS_ALLOCATIONS_QUERY;
